import {
  ObjectClientProps,
  ObjectCompanyProps,
  ObjectEnvironmentProps,
  ObjectOperatorProps,
  ObjectPartnerProps,
} from 'modules/permission/interfaces';

type UpdateObjectsFunction = (
  entity: string,
  objects: string[],
  allSelected?: boolean
) => void;

type PendingObject =
  | ObjectCompanyProps
  | ObjectPartnerProps
  | ObjectEnvironmentProps
  | ObjectClientProps
  | ObjectOperatorProps;

const shouldUpdateObjects = (
  pendingObjects: PendingObject[],
  allItemsSelected: boolean,
  allSelected?: boolean
): boolean => !!pendingObjects.length || allSelected !== allItemsSelected;

const getUpdatedObjects = (
  pendingObjects: PendingObject[],
  dataResults: any[] | undefined,
  allSelected?: boolean
): any[] => {
  const pendingObjectsUUIDs = pendingObjects.map(({ uuid }) => uuid);
  const dataResultsUUIDs = dataResults?.map(({ uuid }) => uuid) || [];

  return allSelected ? [] : [...pendingObjectsUUIDs, ...dataResultsUUIDs];
};

export const handleObjectsSave = (
  pendingObjects: PendingObject[],
  dataResults: any[] | undefined,
  allItemsSelected: boolean,
  updateObjects: UpdateObjectsFunction,
  entity: string,
  allSelected?: boolean
): void => {
  if (shouldUpdateObjects(pendingObjects, allItemsSelected, allSelected)) {
    const updatedObjects = getUpdatedObjects(
      pendingObjects,
      dataResults,
      allSelected
    );
    updateObjects(entity, updatedObjects, allSelected);
  }
};
